import { useQuery } from "react-query";
import {
  CustomModal,
  Pagination,
  TableHeader,
  TableLoading,
} from "../../../../../../components";
import Context from "../../../../../../context";
import values from "../../../../../../values";
import api from "../../../../../../api";
import React, { useState } from "react";
import utils from "../../../../../../utils";
import {
  INVOICES_STATUS,
  PAY_TYPE,
  RECEIVER_TYPE,
  TRANSACTION_STATUS,
} from "../../../../../../values/dropdownItems";
import "./index.scss";
import { useTranslation } from "react-i18next";

const Invoice = () => {
  // ** ===========================================================================================================
  // **                                            Value Validation
  // ** -----------------------------------------------------------------------------------------------------------
  const { showModal, setShowModal, selectedTransaction } = React.useContext(
    Context.TransactionsScreen
  );
  const [page, setPage] = useState<number>(1);

  const invoices = selectedTransaction?.factorsList;
  const { t } = useTranslation();

  // !! -----------------------------------------------------------------------------------------------------------
  // !!                                             End API Call
  // !! ===========================================================================================================

  // ?? ===========================================================================================================
  // ??                                           Use Formik Function
  // ?? -----------------------------------------------------------------------------------------------------------

  // ?? ===========================================================================================================
  // ??                                               JSX Content
  // ?? -----------------------------------------------------------------------------------------------------------

  return (
    <CustomModal
      onClose={() => {
        setShowModal!("NONE");
        // setFormData({});
        // setStep(1);
      }}
      open={showModal === "INVOICES"}
      minWidth={"40vw"}
    >
      <>
        <h6>{t("factors")}</h6>
        <table>
          <TableHeader headers={values.tableHeaders.INVOICE_HEADERS} />
          <tbody>
            {invoices?.map((invoice: any, index: number) => {
              return (
                <>
                  {
                    <tr key={`parent-${index}`}>
                      <td
                        className="pointer"
                        // onClick={() => onClick(parent)}
                      >
                        {index + 1}
                      </td>
                      {/* actions */}
                      <td>
                        {utils.convertNumberToPrice(invoice?.price)}{" "}
                        {t("toman")}
                      </td>
                      <td>
                        {
                          INVOICES_STATUS?.find(
                            (item) => item.value === invoice?.status
                          )?.name
                        }
                      </td>
                      <td>
                        {utils.convertGregorianToJalali({
                          date: invoice?.newSubscriptionDate,
                          format: "jYYYY/jMM/jDD",
                        })}
                      </td>
                      <td>
                        {utils.convertGregorianToJalali({
                          date: invoice?.oldSubscriptionDate,
                          format: "jYYYY/jMM/jDD",
                        })}
                      </td>

                      {/* <td>
                          <div className="table-actions-buttons">
                            <CustomIcon
                              icon="fa fa-credit-card"
                              hoverTitle="پرداخت"
                              
                            />
    
                          </div>
                        </td> */}
                    </tr>
                  }
                </>
              );
            })}
          </tbody>
        </table>
        {/* {status === "success" && data?.result?.totalDocs > 10 && (
          <div className="pagination">
            <Pagination
              page={page}
              totalPages={data?.result?.totalPages}
              onPaginate={(page: number) => setPage(page)}
            />
          </div>
        )} */}
      </>
    </CustomModal>
  );
};

export default Invoice;
